import { normalizeBulkSku } from '@/utils/normalizeBulkSku'

export type CatalogRowForOrphans = {
  bk_sku: string
  wh_sku?: string | null
  bright_catalog_sku?: string | null
}

export type StockForOrphans = {
  sku: string
  product: string
  casesLeft: number
  avgCost: number | null
}

export type OrphanStockRow = {
  _clientId: string
  sku: string
  product: string
  casesLeft: number
  avgCost: number | null
}

export function buildCatalogSkuKeys(rows: CatalogRowForOrphans[]): Set<string> {
  const catalogSkus = new Set<string>()
  for (const row of rows) {
    for (const sku of [row.bk_sku, row.wh_sku, row.bright_catalog_sku]) {
      const key = normalizeBulkSku(sku ?? '')
      if (key) catalogSkus.add(key)
    }
  }
  return catalogSkus
}

export function buildOrphanRows(
  rows: CatalogRowForOrphans[],
  stockBySku: Map<string, StockForOrphans>
): OrphanStockRow[] {
  const catalogSkus = buildCatalogSkuKeys(rows)
  const orphans: OrphanStockRow[] = []
  for (const stock of stockBySku.values()) {
    const key = normalizeBulkSku(stock.sku)
    if (!key || catalogSkus.has(key)) continue
    orphans.push({
      _clientId: `orphan:${key}`,
      sku: stock.sku,
      product: stock.product,
      casesLeft: stock.casesLeft,
      avgCost: stock.avgCost,
    })
  }
  return orphans.sort((a, b) => a.sku.localeCompare(b.sku, undefined, { sensitivity: 'base' }))
}
